<template>
  <div :class="`m-mobile m-mobile-${routeType}-list`" v-if="SpotShow">
    <bs-list :filter="filter" :meta="meta" ref="refId" content-class>
      <template slot="data" slot-scope="slot">
          <ul>
        <li
          v-for="item in slot.data"
          :key="item.destId"
          @click="handleDetail(item)"
        ><div style="float:left;height:100px;width:30%"><img :src="item.imgUrl" style="height:100%;width:100%"></div>
        <div style="float:right;width:70%;padding:10px;height:100px;">
            {{item.destName}}
            </div></li>
     </ul>
      </template>
      <template slot="empty">空数据</template>
    </bs-list>

<bs-list :filter="filter" :meta="meta" ref="refId" content-class v-if="HotelShow">
      <template slot="data" slot-scope="slot">
        <li
          v-for="item in slot.data"
          :key="item.cultId"
          @click="handleDetail(item)"
        >{{item.cultName}}</li>
      </template>
      <template slot="empty">空数据</template>
    </bs-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      routeType: "spot",
      SpotShow:true,
      HotelShow:false,
      TicketShow:false,
      FoodShow:false,
      TDShow:false,
      QuanJingShow:false,
      VideoShow:false,
      meta: {
        module: "destinations",
        field: "spot"
      },
      filter: {
        pageIndex: 1,
        pageSize: 6
      },
      api: null
    };
  },
  props: [
    "metaModule",
    "parentRouteType",
    "spotShow",
    "hotelShow",
    "ticketShow",
    "foodShow",
    "tDShow",
    "quanJingShow",
    "videoShow"
  ],
  components: {
    BsList: () => import("../../components/bs-list"),
    PortalNavTop: () => import("./mobile-nav-top"),
    PortalNavLeft: () => import("./mobile-nav-left"),
    PortalFooter: () => import("./mobile-footer")
  },
  methods: {
    reload(){
        this.routeType=this.parentRouteType;
        this.meta=this.metaModule;
        this.SpotShow=this.spotShow;
        this.HotelShow=this.hotelShow;
        this.TicketShow=this.ticketShow;
        this.FoodShow=this.foodShow;
        this.TDShow=this.tDShow;
        this.QuanJingShow=this.quanJingShow;
        this.VideoShow=this.videoShow;
        debugger;
    },
    handleDetail(item) {
      let _module = this.$route.params._module;
      let _field = this.$route.params._field;
      this.$router.push({
        path: `/mobile/cult/detail/${_module}/${_field}_detail/${item.cultId}`
      });
    }
  },
  created() {
    this.$menuFn.setTitle("mobile-cult-list");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-cult-list") {
        this.$menuFn.setTitle("mobile-cult-list");
      }
      let contains = this.$loadRouteData(
        from,
        to,
        this.routeType,
        "list",
        "mobile",
        true
      );
      if (this.routeWatch && contains) {
        this.$refs["refId"].clearData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style>
    ul,li{
        list-style: none;
    }
</style>